import { setState } from 'Utils/Store';

export const layoutInitialState = {
  footerContent: {
    content: null,
    isLoaded: false,
  },
  isConfirmSuccess: false,
  confirmationMsg: '',
  showOverlay: false,
  overlayMessage: '',
  showOverlayLoader: false,
};

export const updateFooter = (payload) => {
  setState('pageLayout.footerContent', { content: payload, isLoaded: true });
};

export const updateConfirmation = (payload) => {
  setState('pageLayout', { isConfirmSuccess: true, confirmationMsg: payload });
};

export const clearConfirmation = () => {
  setState('pageLayout', { isConfirmSuccess: false, confirmationMsg: '' });
};

export const showOverlay = (message, showLoader = false) => {
  setState('pageLayout', { showOverlay: true, overlayMessage: message, showOverlayLoader: showLoader });
};

export const hideOverlay = () => {
  setState('pageLayout', { showOverlay: false, overlayMessage: '', showOverlayLoader: false });
};
